import { useGetHxTrainingPageQuery } from 'store/services/hxTraining';

import LoadingWrapper from 'components/LoadingWrapper';
import CoverWithOverlay from 'components/CoverWithOverlay/CoverWithOverlay';
import { Button } from 'components/UI/new';
import { openInNewTab } from 'utils/openInNewTab';
import { ContentfulRenderer } from 'components';
import { getUrlFromCta } from 'utils/getUrlFromCta';
import styles from './styles.module.scss';
import HxTrainingBlock from './HxTrainingBlock';
import HxTrainingOTTSection from './HxTrainingOTTSection';

const HxTrainingPage = () => {
  const { data, isLoading, isError } = useGetHxTrainingPageQuery();
  // Filter empty resources (drafts)
  const resources = data?.resources.filter((resource) => Boolean(resource));

  return (
    <LoadingWrapper loading={isLoading} error={isError}>
      {data && (
        <div className={styles.wrapper}>
          <CoverWithOverlay
            mediaUrl={data.hero}
            heroWithFocalPoint={data.heroWithFocalPoint}
          />
          <h1 className={styles.title}>{data.title}</h1>
          <HxTrainingBlock
            title={data.newBookingPlatformSection?.title}
            description={data.newBookingPlatformSection?.description}
            icon={data.newBookingPlatformSection?.icon}
            iconColor="light"
            buttons={
              <>
                <Button
                  key="newBookingPlatformSectionCta"
                  variant="primary"
                  size="normal"
                  icon="downloadAlternative"
                  iconPosition="left"
                  onClick={() => {
                    openInNewTab(
                      getUrlFromCta(data.newBookingPlatformSection?.cta)
                    );
                  }}
                >
                  {data.newBookingPlatformSection?.cta?.title}
                </Button>
                <Button
                  key="newBookingPlatformSectionCtaSecondary"
                  variant="danger"
                  size="normal"
                  icon="play"
                  iconPosition="left"
                  onClick={() => {
                    openInNewTab(
                      getUrlFromCta(
                        data.newBookingPlatformSection?.ctaSecondary
                      )
                    );
                  }}
                >
                  {data.newBookingPlatformSection?.ctaSecondary?.title}
                </Button>
              </>
            }
          />
          {resources.length > 0 && (
            <div className={styles.resourcesSection}>
              <h2 className={styles.resourcesTitle}>{data.resourcesTitle}</h2>
              <div className={styles.resourcesDescription}>
                <ContentfulRenderer>
                  {data.resourcesDescription}
                </ContentfulRenderer>
              </div>
              <div className={styles.resources}>
                {resources.map((resource) => (
                  <HxTrainingBlock
                    key={resource.id}
                    title={resource.title}
                    description={resource.description}
                    icon={resource.icon}
                    iconColor="light"
                    compact
                    buttons={
                      <Button
                        variant="secondary"
                        size="normal"
                        icon="downloadAlternative"
                        iconPosition="left"
                        onClick={() => {
                          openInNewTab(getUrlFromCta(resource.cta));
                        }}
                      >
                        {resource.cta?.title}
                      </Button>
                    }
                  />
                ))}
              </div>
            </div>
          )}
          {data.brandTrainingTitle && (
            <HxTrainingBlock
              title={data.brandTrainingTitle}
              description={data.brandTrainingDescription}
              icon="graduationCap"
              iconColor="dark"
              customContent={
                <HxTrainingOTTSection
                  title={data.ottTitle}
                  description={data.ottDescription}
                  cta={data.ottCta}
                />
              }
            />
          )}
        </div>
      )}
    </LoadingWrapper>
  );
};

export default HxTrainingPage;
